<template>
  <div class="container">
    <div class="goods">
      <RefundGoodsItem
        v-if="Object.keys(subOrderInfo).length > 0"
        :cart-info="subOrderInfo.cart_info"
      ></RefundGoodsItem>
    </div>

    <div class="selection">
      <div class="option" @click="toDetail(1)" v-if="subOrderInfo.goods_area_info.return_type1 ==1">
        <div class="left">
          <div class="pictrue">
            <img src="@images/icon_drawback.png" alt="" />
          </div>
          <div class="text">
            <div class="title">仅退款</div>
            <div class="desc">未收到货（包含未签收），或卖家协商同意前提下</div>
          </div>
        </div>
        <img class="arrow" src="@images/arrow.png" alt="" />
      </div>
      <div class="option" @click="toDetail(2)" v-if="subOrderInfo.goods_area_info.return_type2 ==1 && subOrderInfo.delivery_status==1">
        <div class="left">
          <div class="pictrue">
            <img src="@images/icon_returnrefund.png" alt="" />
          </div>
          <div class="text">
            <div class="title">退货退款</div>
            <div class="desc">已收到货，需要退已收到的货物</div>
          </div>
        </div>
        <img class="arrow" src="@images/arrow.png" alt="" />
      </div>
      <div class="option" @click="toDetail(3)" v-if="subOrderInfo.goods_area_info.return_type3 ==1 && subOrderInfo.delivery_status==1">
        <div class="left">
          <div class="pictrue">
            <img src="@images/icon_change.png" alt="" />
          </div>
          <div class="text">
            <div class="title">换货</div>
            <div class="desc">已收到货，需要更换已收到的货物</div>
          </div>
        </div>
        <img class="arrow" src="@images/arrow.png" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import RefundGoodsItem from "@components/RefundGoodsItem";
import { getReturnProductInfo } from "@api/user";
export default {
  name: "RefundSelect",
  components: {
    RefundGoodsItem
  },
  data() {
    return {
      cart_id: null,
      oid: null,
      unique: null,
      subOrderInfo: {
        goods_area_info:{
          return_type1:0,
          return_type2:0,
          return_type3:0
        }
      }
    };
  },
  mounted() {
    this.oid = this.$route.query.oid;
    this.unique = this.$route.query.unique;
    this.$nextTick(() => {
      this.getReturnProductInfo();
    });
  },
  methods: {
    toDetail(type) {
      this.$router.push(
        "/user/refund_form?type=" +
          type +
          "&oid=" +
          this.oid +
          "&unique=" +
          this.unique
      );
    },
    getReturnProductInfo() {
      let params = {
        oid: this.oid,
        unique: this.unique,
        cart_id: this.cart_id
      };
      getReturnProductInfo(params).then(res => {
        this.subOrderInfo = res.data;
      });
    }
  }
};
</script>

<style scoped lang="scss">
.container {
  .goods {
    background-color: #fff;
    padding: 0.2rem 0.32rem;
  }
  .selection {
    margin-top: 0.2rem;
    background-color: #fff;
    .option {
      display: flex;
      flex-direction: row;
      margin: 0 0.32rem;
      padding: 0.2rem 0;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #f0f0f0;
      .left {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
        .pictrue {
          width: 0.4rem;
          height: 0.4rem;
          img {
            width: 100%;
          }
        }
        .text {
          margin-left: 0.2rem;
          .title {
            font-size: 0.28rem;
            color: #333;
          }
          .desc {
            font-size: 0.24rem;
            color: #999;
            margin-top: 0.1rem;
          }
        }
      }
      .arrow {
        width: 0.16rem;
        height: 0.24rem;
      }
    }
  }
}
</style>
